export const API_PREFIX = '/api/v1';

export const IMAGES_PREFIX = '/images';

export const PDFS_PREFIX = '/pdfs';

export const SIDE_MENU_STATUS_KEY = '__CJMH_CLIENT_SIDE_MENU_STATUS';
